// extracted by mini-css-extract-plugin
export default {"Container":"WidgetError_Container__rt0ny","Text":"WidgetError_Text__wv9lW","RetryButton":"WidgetError_RetryButton__41Rjx"};